<div *ngIf="!codeGenerated" class="ui-g">
  <div class="ui-g-12">
    <form [formGroup]="generateForm" (ngSubmit)="onSubmit()">
      <div class="ui-g">
        <div class="ui-g-12 pb-3">
          <span class="ui-float-label">
            <input
              pInputText
              id="forename"
              class="b2c-input"
              formControlName="forename"
              maxlength="100"
            />
            <label for="forename">Forename*</label>
          </span>
          <div *ngIf="showForenameError()" class="input-error">Forename required</div>
        </div>

        <div class="ui-g-12 pb-3">
          <span class="ui-float-label">
            <input
              pInputText
              id="surname"
              class="b2c-input"
              formControlName="surname"
              maxlength="100"
            />
            <label for="surname">Surname*</label>
          </span>
          <div *ngIf="showSurnameError()" class="input-error">Surname required</div>
        </div>

        <div class="ui-g-12 pb-3">
          <span class="ui-float-label">
            <input
              pInputText
              id="email"
              class="b2c-input"
              formControlName="email"
              maxlength="100"
            />
            <label for="email">Email*</label>
          </span>
          <div *ngIf="getEmailErrorMessage()" class="input-error">
            {{ getEmailErrorMessage() }}
          </div>
        </div>
      </div>
      <div class="ui-g-12 pb-3" *ngIf="formReady">
        <turnstile
          #turnstileWidget
          [siteKey]="turnstileSiteKey"
          theme="light"
          (verified)="onTurnstileVerified($event)"
          (expired)="onTurnstileExpired()"
          (errored)="onTurnstileError()"
        >
        </turnstile>
      </div>
      <div class="ui-g-12 pb-3" *ngIf="formReady">
        <div class="big-button selected proceed-button" (click)="onSubmit()">
          <span *ngIf="loading">Generating...</span>
          <span *ngIf="!loading">Generate Discount</span>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="confirmation-body" *ngIf="codeGenerated">
  <div>
    <div class="text-center">
      <div class="header-line-1">Your discount is on the way</div>
    </div>

    <div class="flex-grow-1 confirmation-message">
      <div class="text-center">
        <div class="mt-2 mb-2">You will receive your discount code at:</div>
        <div class="mt-2 mb-2" style="font-size: 20px">
          <strong>{{ generateForm.controls.email.value }}</strong>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [modal]="true"
  [styleClass]="'dialog-container'"
  [(visible)]="showErrorDialog"
  [closable]="true"
  [closeOnEscape]="true"
  [style]="{ 'max-width': '1024px', 'background-color': '#fff' }"
  position="top"
>
  <p-header>Something went wrong</p-header>
  <div>
    We apologise that we are not able to generate a discount code at this time. Please contact us
  </div>
</p-dialog>
